<template>
    <div v-if="show">
        <!-- home->create->confirm1->create->home -->
        <!-- home->show->edit->confirm2->edit->show->home -->
        <confirm-header v-if="opt == 'create_confirm'" :page-name="pageName" do-cust @cust="backPage"></confirm-header>
        <confirm-header v-else-if="opt == 'edit_confirm'" :page-name="pageName" do-cust @cust="backPage"></confirm-header>
        <confirm-header v-else :page-name="pageName"></confirm-header>
        <div class="container">
            <div class="card mb-2">
                <div class="card-body">
                    <form-item lab="契約状態">{{converVal('contract_flg', form.contract_flg)}}</form-item>

                    <form-item v-if="form.apply_id" lab="応募ID">{{form.apply_id}}</form-item>
                    <form-item v-else lab="応募ID"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.pj_group" lab="案件会社">{{form.pj_group_nm}}</form-item>
                    <form-item v-else lab="案件会社"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.pj_nm" lab="案件名">{{form.pj_nm}}</form-item>
                    <form-item v-else lab="案件名"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.pj_id" lab="案件ID">{{form.pj_id}}</form-item>
                    <form-item v-else lab="案件ID"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.te_group" lab="要員会社">{{form.te_group_nm}}</form-item>
                    <form-item v-else lab="要員会社"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.relation_cmp" lab="所属関係">{{converVal('relation_cmp', form.relation_cmp)}}</form-item>
                    <form-item v-else lab="所属関係"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.private_nm" lab="要員名前">{{form.private_nm}}</form-item>
                    <form-item v-else lab="要員名前"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.user_id" lab="ユーザーID">{{form.user_id}}</form-item>
                    <form-item v-else lab="ユーザーID"><span class="text-danger">未入力</span></form-item>

                    <form-item v-if="form.te_id" lab="履歴書ID">{{form.te_id}}</form-item>
                    <form-item v-else lab="履歴書ID"><span class="text-danger">未入力</span></form-item>

                    <form-item lab="契約開始">{{form.start_date | dformatd}}</form-item>
                    <form-item lab="契約終了">{{form.end_date | dformatd}}</form-item>

                    <form-item v-if="form.note" lab="備考">{{form.note}}</form-item>
                    <form-item v-else lab="備考"><span class="text-danger">未入力</span></form-item>
        
                    <div class="card mb-2 mt-5">
                        <div class="card-body">
                            <div v-if="opt == 'create_confirm'" class="row form-group justify-content-center mb-0">
                                <div class="col-sm-3">
                                    <button class="btn btn-danger btn-block btn-lg" @click="doSubmit">
                                        <i class="fas fa-save"></i>&nbsp;契約情報登録
                                    </button>
                                </div>
                            </div>
                            <div v-if="opt == 'edit_confirm'" class="row form-group justify-content-center mb-0">
                                <div class="col-sm-3">
                                    <button class="btn btn-danger btn-block btn-lg" @click="doSubmit">
                                        <i class="fas fa-save"></i>&nbsp;契約情報更新
                                    </button>
                                </div>
                            </div>
                            <div v-if="opt == 'show'" class="row form-group justify-content-center mb-0">
                                <div class="col-sm-3">
                                    <button class="btn btn-success btn-block btn-lg" @click="doEdit">
                                        <i class="fas fa-edit"></i>&nbsp;契約情報編集
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ConfirmHeader from 'pages/commons/header/Header'
    import FormItem from 'pages/commons/form/Confirm'

    export default {
        props: {
            form: Object,
            opt: String
        },
        components: {
            ConfirmHeader,
            FormItem,
        },
        computed: {
            show () {
                return Object.keys(this.form).length > 0
            },
            pageName () {
                if (this.opt == 'create_confirm') {
                    return "入力内容確認"
                }
                if (this.opt == 'edit_confirm') {
                    return "編集内容確認"
                }
                return "契約情報"
            },
        },
        methods: {
            backPage () {
                if (this.opt == 'create_confirm') {
                    this.$parent.changeOperat('create')
                }
                if (this.opt == 'edit_confirm') {
                    this.$parent.changeOperat('edit')
                }
            },
            converVal (name,value) {
                return this.$parent.converVal(name,value)
            },
            doSubmit () {
                this.$parent.doSubmit()
            },
            doEdit () {
                this.$parent.changeOperat('edit')
            },
            openMsg (msg, lev) {
                this.$parent.openMsg(msg, lev)
            },
        }
    }
</script>

<style>

</style>
